<template>
  <div class="form-wrap">
    <div class="search-form">
      <slot :formItemVisible="formVisible"></slot>
    </div>
    <div
      @click="handleClick"
      :title="formVisible ? '收起' : '展开'"
      class="ctrl"
    >
      {{ formVisible ? '收起' : '展开' }}
      <el-button
        class="ctrl-btn"
        size="small"
        :class="formVisible ? 'el-icon-arrow-up' : 'el-icon-arrow-down'"
      >
      </el-button>
    </div>

  </div>
</template>

<script>
export default {
  name: 'form-wrap',
  props: {
    defaultVisible: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      formVisible: true,
    };
  },
  created() {
    this.formVisible = this.defaultVisible;
  },
  methods: {
    handleClick() {
      this.formVisible = !this.formVisible;
    },
  },
};
</script>

<style lang="scss" scoped>
  .form-wrap {
    margin-bottom: 30px;
    position: relative;
    .search-form {
      border: 1px solid #EBEEF5;
    }
    .ctrl {
      width: 100px;
      height: 18px;
      border: 1px solid #EBEEF5;
      border-top: none;
      background-color: #ffffff;
      border-radius: 0 0 5px 5px;
      font-size: 12px;
      position: absolute;
      bottom: -17px;
      left: 50%;
      margin-left: -50px;
      text-align: center;
      cursor: pointer;

    }
    .ctrl-btn {
      border: none;
      padding: 0;
    }
    .ctrl-btn:hover,
    .ctrl-btn:focus {
      color: #606266;
      background-color: #fff;
      border-color: #EBEEF5;
    }
  }
</style>
